// =============================================================================
// AUCTION-HUB-BID.JS — Auction hub collection page bidding UI
// =============================================================================
// Handles the auction hub (/collections/auction-hub) browsing and absentee
// bidding interface. Features: product filtering by tag, favorites, bid
// submission (slow & steady proxy bidding), and bid status display.
// Reads config from window.MHV_AUCTION_HUB_CONFIG (set by section Liquid).

(function() {
  'use strict';

  // SVG icon constants (replacing Liquid {% render 'icon-success' %} / {% render 'icon-error' %})
  var ICON_SUCCESS_SVG = '<svg aria-hidden="true" focusable="false" class="icon icon-success" viewBox="0 0 13 13"><path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"/><path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"/><path d="M4.10645 6.7688L6.13766 8.62553" stroke="white"></svg>';

  var ICON_ERROR_SVG = '<svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></svg>';

  // Read customer email from config set by Liquid
  var config = window.MHV_AUCTION_HUB_CONFIG || {};
  var customerEmail = config.customerEmail || '';

  // Quote-safe attribute escaper (SEC-61) for server-supplied URLs placed in href="…".
  var escA = function (s) {
    if (window.MHV && typeof window.MHV.escapeAttr === 'function') return window.MHV.escapeAttr(s);
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  // ── Ban lockdown ──────────────────────────────────────────────────────────
  // Bidding is enforced server-side (the bid endpoint rejects banned customers with
  // 403). This locks the visible UI too so a customer banned mid-auction sees it
  // immediately. Triggered by: the page-wide 'mhv:user-banned' event (chat-widget,
  // live page) OR a 403 ban response from a bid attempt. Idempotent.
  var _bidBanned = false;
  function applyBannedLockdown(msg) {
    _bidBanned = true;
    try { window.MHV_IS_BANNED = true; } catch (e) {}
    // Disable quick-bid buttons + close any open bid lightbox.
    try {
      document.querySelectorAll('[id^="quick_bid_"]').forEach(function(b) { b.disabled = true; b.style.opacity = '0.5'; b.style.pointerEvents = 'none'; });
      document.querySelectorAll('[id^="hub-bid-lightbox-"]').forEach(function(lb) { lb.style.display = 'none'; });
      document.body.style.overflow = '';
    } catch (e) {}
    if (!document.getElementById('mhv-bid-banned-banner')) {
      var banner = document.createElement('div');
      banner.id = 'mhv-bid-banned-banner';
      banner.textContent = '🚫 ' + (msg || 'Your account has been banned. You can no longer bid.');
      banner.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#7a1f1f;color:#fff;padding:13px 16px;text-align:center;font-weight:700;font-size:15px;font-family:Arial,sans-serif;box-shadow:0 -2px 12px rgba(0,0,0,0.4);';
      document.body.appendChild(banner);
    }
  }
  function isBanned() { return _bidBanned || window.MHV_IS_BANNED === true; }
  document.addEventListener('mhv:user-banned', function() { applyBannedLockdown(); });
  if (window.MHV_IS_BANNED === true) applyBannedLockdown();

  // ── Per-auction registration gate (Phase 2) ────────────────────────────────
  // Reveal the "Register for this auction" block for customers not registered for this
  // auction. When the server reports enforcement is ON, also hide the bidding UI (the bid
  // endpoint is the source of truth — it 403s AUCTION_REGISTRATION_REQUIRED regardless).
  function checkAuctionRegistration() {
    var auction = config.collectionHandle || '';
    if (!auction || !customerEmail || !window.mhvFetch) return; // logged-in customers only
    var SERVER = (window.MHV && window.MHV.SERVER_URL) || 'https://mhv-viewer-app-1df0c0c61ed9.herokuapp.com';
    var ready = window.MHV_CUSTOMER_KEY_READY || Promise.resolve();
    ready.then(function () {
      return window.mhvFetch(SERVER + '/auction-register/status?auction=' + encodeURIComponent(auction));
    }).then(function (r) { return r.json(); }).then(function (d) {
      // Dormant until enforcement is ON: no gate, no modal, no vaulting until
      // AUCTION_REGISTRATION_ENFORCE=1 (d.enforced). Existing bidders never see it.
      if (!d || d.registered || !d.enforced) { clearAutoRegFlag(); return; }
      // Mark the page: mhv-bidding-phase.css reveals the "Register to bid" pills (one between
      // the locked pills before bidding opens; a fallback in place of the bid form once it's
      // open) and hides the live bid form. Current-bid badge stays visible (outside the form).
      document.documentElement.classList.add('mhv-reg-required');
      document.querySelectorAll('.mhv-auction-reg-link').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); openAuctionRegister(auction); });
      });
      // Arrived here from a logged-out "Register to bid" link (they just created/​logged into an
      // account): auto-open the per-auction modal so registering for THIS auction is the obvious
      // immediate next step — no hunting for the button, no "didn't I just do this?".
      if (hasAutoRegFlag()) { clearAutoRegFlag(); openAuctionRegister(auction); }
    }).catch(function () {});
  }
  // "Just came from a logged-out Register/Log-in link" signal. Primary: the sessionStorage intent
  // set on click (survives the whole same-origin register→login→hub round trip no matter how
  // Shopify redirects). Also honor a legacy ?auction_register=1 URL flag.
  function hasAutoRegFlag() {
    try { if (sessionStorage.getItem('mhv_auction_reg_intent') === '1') return true; } catch (e) {}
    try { return new URLSearchParams(window.location.search).get('auction_register') === '1'; }
    catch (e) { return false; }
  }
  // One-shot: clear the intent + any legacy URL flag so a refresh doesn't re-pop the modal, and
  // drop the post-register navigation fallback (else a later /account visit would bounce here).
  function clearAutoRegFlag() {
    try { sessionStorage.removeItem('mhv_auction_reg_intent'); } catch (e) {}
    try { sessionStorage.removeItem('mhv_post_register_return'); } catch (e) {}
    try {
      var u = new URL(window.location.href);
      if (!u.searchParams.has('auction_register')) return;
      u.searchParams.delete('auction_register');
      window.history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
  }
  // Open the registration modal; on success, drop the gate + restore the bidding UI
  // (clearing the inline display override hands control back to the phase CSS classes).
  function openAuctionRegister(auction, onDone) {
    if (!window.MHVAuctionRegister) { alert('Registration is unavailable right now. Please refresh and try again.'); return; }
    window.MHVAuctionRegister.open({ auctionCode: auction, onRegistered: function () {
      // Registration complete — drop the marker so the Register pills hide and the phase CSS
      // controls the bid form again (it shows once bidding is open).
      document.documentElement.classList.remove('mhv-reg-required');
      if (onDone) try { onDone(); } catch (e) {}
    } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkAuctionRegistration);
  else checkAuctionRegistration();

  // "3 ♥" / "57 👁" — the favourite and view counts on a lot are a number beside
  // a glyph (2026-09-13; they read "3 Favs" / "57 Views" before). MHV.countGlyph
  // (mhv-utils-5.js) is the one spelling; the words are the fallback if the
  // utils bundle somehow is not there.
  function favGlyph(n) {
    n = Number(n) || 0;
    return (window.MHV && MHV.countGlyph) ? MHV.countGlyph(n, 'heart') : (n + ' Fav' + (n === 1 ? '' : 's'));
  }
  function viewGlyph(n) {
    n = Number(n) || 0;
    return (window.MHV && MHV.countGlyph) ? MHV.countGlyph(n, 'eye') : (n + ' View' + (n === 1 ? '' : 's'));
  }

  // Per-lot view beacon (feeds the home "Hot Lots" carousel). Fire once per lot
  // per page load when a customer opens its bid lightbox — a deliberate signal of
  // interest. Fire-and-forget; never blocks bidding.
  // ⚠️ Deduped per BROWSER SESSION (sessionStorage), not per page load: a refresh
  // or a second look at the same lot in the same sitting is one view, not two.
  // Views now print on the card ("N Views") and feed the Hot Lot score.
  var _viewedLots = {};
  function recordLotView(productId) {
    if (!productId || _viewedLots[productId]) return;
    _viewedLots[productId] = true;
    try {
      var key = 'mhv_lv_' + productId;
      if (window.sessionStorage && sessionStorage.getItem(key)) return;
      if (window.sessionStorage) sessionStorage.setItem(key, '1');
    } catch (e) { /* storage blocked → count it */ }
    try {
      var SERVER = (window.MHV && window.MHV.SERVER_URL) || '';
      if (!SERVER) return;
      (window.mhvFetch || window.fetch)(SERVER + '/api/lot-view', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productId: String(productId),
          sessionCode: config.collectionHandle || null,
          customerId: config.customerId || config.bidderNumber || null,
          source: 'hub-bid'
        })
      }).catch(function() { /* silent */ });
    } catch (e) { /* silent */ }
  }

  // Dynamic quick-bid increments — scale with the current bid (no longer a
  // per-session setting). Used to build the two "raise" buttons on lots that
  // already have bids. Must mirror the Liquid if/elsif chain in
  // snippets/auction-hub-bid.liquid so server-rendered buttons match.
  // (Opening buttons on no-bid lots are rendered entirely in Liquid from the
  // session start tier, or from the lot's minimum_bid when one is set.)
  function quickBidIncrementsFor(cur) {
    cur = parseFloat(cur) || 0;
    if (cur < 10) return [1, 5];
    if (cur < 100) return [5, 10];
    if (cur < 250) return [10, 25];
    if (cur < 500) return [25, 50];
    if (cur < 1000) return [50, 100];
    return [100, 250];
  }

  function buildQuickBidButtonsHtml(productId, lowAmount, highAmount) {
    return '\
      <button type="button" \
              class="quick-bid-btn" \
              id="quick_bid_low_' + productId + '"\
              data-product-id="' + productId + '"\
              data-bid-amount="' + lowAmount + '"\
              onclick="handleQuickBidClick(this)">\
        Bid $' + formatQuickBidAmount(lowAmount) + '\
      </button>\
      <button type="button" \
              class="quick-bid-btn" \
              id="quick_bid_high_' + productId + '"\
              data-product-id="' + productId + '"\
              data-bid-amount="' + highAmount + '"\
              onclick="handleQuickBidClick(this)">\
        Bid $' + formatQuickBidAmount(highAmount) + '\
      </button>\
    ';
  }

  // Track in-flight bid submissions to prevent duplicate submissions
  // Key: productId, Value: { timestamp, bidAmount, inFlight }
  var bidSubmissionTracker = {};

  // Prevent duplicate submissions within this time window (milliseconds)
  var DUPLICATE_PREVENTION_WINDOW = 30000; // 30 seconds

  // Global variables for lightbox state management
  var isLightboxOpen = false;

  // Function to format the currency in the input field
  function formatCurrency(input) {
    var value = input.value.replace(/[^0-9.]/g, '');
    if (value) {
      var numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        // Format with commas using the formatWithCommas function
        input.value = '$' + formatWithCommas(numValue);
      } else {
        input.value = '';
      }
    } else {
      input.value = '';
    }
  }

  // Function to round down to nearest $0.50 increment
  function roundDownToHalfDollar(amount) {
    // Convert to cents for easier calculation
    var cents = Math.floor(amount * 100);
    // Round down to nearest 50 cents
    var roundedCents = Math.floor(cents / 50) * 50;
    // Convert back to dollars
    return roundedCents / 100;
  }

  // Function to format number with commas
  function formatWithCommas(amount) {
    return amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Format quick bid amounts: always whole dollars (round any cents UP), no decimals.
  function formatQuickBidAmount(amount) {
    return Math.ceil(Number(amount) || 0).toLocaleString('en-US');
  }

  // ===== Quick Bid Functions =====

  // Handle quick bid button click — opens the bid confirmation lightbox with the quick bid amount
  function handleQuickBidClick(button) {
    if (isBanned()) { applyBannedLockdown(); return; }
    var productId = button.dataset.productId;
    var bidAmount = parseFloat(button.dataset.bidAmount);

    // Set the bid amount in the lightbox input
    var bidInputInLightbox = document.getElementById('max_bid_' + productId + '_lightbox');
    if (bidInputInLightbox) {
      bidInputInLightbox.value = '$' + formatWithCommas(bidAmount);
      bidInputInLightbox.readOnly = false;
      bidInputInLightbox.setAttribute('data-initial-bid', bidAmount.toFixed(2));
    }

    // Update BP summary
    updateBidSummary(productId, bidAmount);

    // Reset the confirm button
    var confirmButton = document.getElementById('confirm_button_' + productId);
    if (confirmButton) {
      confirmButton.classList.remove('button-update');
      confirmButton.textContent = 'Confirm Bid';
      confirmButton.onclick = function() { submitBidForm(productId); };
    }

    // Set up bid change listener
    setupBidChangeListener(productId);

    // Open the lightbox
    recordLotView(productId);   // deliberate per-lot interest → home Hot Lots
    document.getElementById('hub-bid-lightbox-' + productId).style.display = 'flex';
    isLightboxOpen = true;
    window.history.pushState({ lightboxOpen: true }, '');
    document.body.style.overflow = 'hidden';
  }

  // Function to update the bid summary (BP breakdown) in the lightbox
  function updateBidSummary(productId, bidAmount) {
    // HOUSE RULE (owner, 2026-08-15 — Q1): respect the premium that is actually SET.
    // A genuine 0% is a real thing and must be honoured; `parseFloat(v) || 10` read it as
    // falsy and quoted a 10% premium the buyer did not owe. Only a MISSING/unparseable
    // value falls back, and an auction can no longer be created without a premium set.
    var bpPctEl = document.getElementById('bp_pct_' + productId);
    var bpParsed = bpPctEl ? parseFloat(bpPctEl.value) : NaN;
    var bpPct = isNaN(bpParsed) ? 10 : bpParsed;
    var bpAmount = Math.round(bidAmount * bpPct) / 100;
    var totalWithBp = bidAmount + bpAmount;

    var bidEl = document.getElementById('bid_summary_bid_' + productId);
    var bpEl = document.getElementById('bid_summary_bp_' + productId);
    var totalEl = document.getElementById('bid_summary_total_' + productId);

    if (bidEl) bidEl.textContent = '$' + formatWithCommas(bidAmount);
    if (bpEl) bpEl.textContent = '$' + formatWithCommas(bpAmount);
    if (totalEl) totalEl.textContent = '$' + formatWithCommas(totalWithBp);

    // Update the bid-rule info based on bid amount + high-bidder status.
    // Applies to both quick bids and custom bids (both open this confirmation).
    var ruleEl = document.getElementById('bid_rule_info_' + productId);
    if (ruleEl) {
      var bidderStatusEl = document.getElementById('bidder_status_message_' + productId);
      var isHighBidder = bidderStatusEl && bidderStatusEl.textContent.indexOf('high bidder') !== -1;

      // Does the lot already have bids? (read the current-bid display)
      var hasBids = false;
      var curBidEl = document.getElementById('current_bid_' + productId);
      if (curBidEl) {
        var cbMatch = curBidEl.textContent.match(/\$?([\d,]+(?:\.\d{2})?)/);
        if (cbMatch) hasBids = parseFloat(cbMatch[1].replace(/,/g, '')) > 0;
      }

      // Opening floor = greater of the lot's minimum bid and the $25 threshold.
      // A first bid above the floor opens the current bid AT the floor.
      var minInput = document.getElementById('quickbid_minimum_bid_' + productId);
      var perItemMin = minInput ? (parseFloat(minInput.value) || 0) : 0;
      var openingFloor = Math.max(perItemMin, 25);

      var notified = ' You\'ll be notified if you\'re outbid.';

      if (isHighBidder && bidAmount <= 25) {
        ruleEl.textContent = 'You\'re the high bidder. For bids of $25 or less, the current bid updates to your full bid amount.' + notified;
      } else if (isHighBidder) {
        ruleEl.textContent = 'You\'re the high bidder. The current bid stays where it is — only your max bid increases. If others bid against you, we\'ll bid on your behalf up to your max.' + notified;
      } else if (!hasBids && bidAmount > openingFloor && openingFloor === 25) {
        // First bid over $25 on a lot governed by the $25 rule (no min, or a min
        // of $25 or less): the current bid opens at $25. Lots with a higher
        // minimum are outside the $25 rule, so we skip this note and just explain
        // the proxy behavior below.
        ruleEl.textContent = 'The current bid will be set to $25. If others bid against you, we\'ll bid on your behalf up to your max.' + notified;
      } else if (bidAmount <= 25) {
        ruleEl.textContent = 'For bids of $25 or less, your full bid amount becomes the current bid.' + notified;
      } else {
        ruleEl.textContent = 'If others bid against you, we\'ll bid on your behalf up to your max.' + notified;
      }
    }
  }

  // Reset quick bid UI buttons after a successful bid via the lightbox
  function resetQuickBidUI(productId, newCurrentBid, isHighBidder) {
    if (newCurrentBid === undefined) newCurrentBid = null;
    if (isHighBidder === undefined) isHighBidder = false;

    var quickBidSection = document.getElementById('quick_bid_section_' + productId);
    var container = document.getElementById('quick_bid_buttons_' + productId);

    // Hide quick bids if user is high bidder
    if (isHighBidder && quickBidSection) {
      quickBidSection.style.display = 'none';
      return;
    }

    // Show quick bids if user is not high bidder (they were outbid)
    if (!isHighBidder && quickBidSection) {
      quickBidSection.style.display = '';
    }

    if (!container) return;

    // If we have a new current bid, update the quick bid buttons
    if (newCurrentBid !== null && newCurrentBid > 0) {
      var inc = quickBidIncrementsFor(newCurrentBid);
      var lowAmount = Math.ceil(newCurrentBid + inc[0]);
      var highAmount = Math.ceil(newCurrentBid + inc[1]);
      container.innerHTML = buildQuickBidButtonsHtml(productId, lowAmount, highAmount);
    } else {
      var allButtons = container.querySelectorAll('.quick-bid-btn');
      allButtons.forEach(function(btn) {
        var amount = parseFloat(btn.dataset.bidAmount);
        btn.innerHTML = 'Bid $' + formatQuickBidAmount(amount);
      });
    }
  }

  // Function to update bid and reload lightbox content
  function updateBid(productId) {
    var bidInput = document.getElementById('max_bid_' + productId + '_lightbox');
    var messageElement = document.getElementById('bid_submission_message_' + productId);
    var newBidValue = bidInput.value.replace(/[^0-9.]/g, '');
    var newBid = parseFloat(newBidValue);

    // Clear any existing server messages
    if (messageElement) {
      messageElement.style.display = 'none';
      messageElement.innerHTML = '';
    }

    if (isNaN(newBid) || newBid <= 0) {
      messageElement.style.display = 'inline';
      messageElement.style.color = 'var(--mhv-error)';
      messageElement.innerHTML = 'Please enter a valid bid amount.';
      return;
    }

    // Round down to nearest $0.50
    var roundedBid = roundDownToHalfDollar(newBid);

    // Check minimum bid — $1 floor or per-item minimum_bid metafield, whichever is higher
    var minimumBid = 1.00;
    var perItemMinInputUpd = document.getElementById('quickbid_minimum_bid_' + productId);
    if (perItemMinInputUpd) {
      var perItemMinUpd = parseFloat(perItemMinInputUpd.value) || 0;
      if (perItemMinUpd > minimumBid) minimumBid = perItemMinUpd;
    }
    if (roundedBid < minimumBid) {
      messageElement.style.display = 'inline';
      messageElement.style.color = 'var(--mhv-error)';
      messageElement.innerHTML = '$' + minimumBid.toFixed(2) + ' is the minimum bid for this lot.';
      return;
    }

    // Get the current bid and validate
    var currentBidElement = document.getElementById('current_bid_' + productId);
    var currentBid = 0;
    if (currentBidElement) {
      var currentBidText = currentBidElement.textContent;
      var currentBidMatch = currentBidText.match(/\$?([\d,]+(?:\.\d{2})?)/);
      if (currentBidMatch) {
        currentBid = parseFloat(currentBidMatch[1].replace(/,/g, ''));
      }
    }

    // Check if the new bid is at least $1.00 greater than the current bid
    // Use a small tolerance (0.01) to handle floating point precision
    if (currentBid > 0 && roundedBid < currentBid + 0.99) {
      messageElement.style.display = 'inline';
      messageElement.style.color = 'var(--mhv-error)';
      messageElement.innerHTML = 'Your bid must be at least $1.00 greater than the current bid.';
      return;
    }

    // Clear any error messages if validation passed
    if (messageElement) {
      messageElement.style.display = 'none';
      messageElement.innerHTML = '';
    }

    // Update the bid input with rounded value (with commas if necessary)
    bidInput.value = '$' + formatWithCommas(roundedBid);

    // Update the data-initial-bid attribute to the new rounded value
    bidInput.setAttribute('data-initial-bid', roundedBid.toFixed(2));

    // Update the initial bid input field with the new value (for consistency)
    var initialInput = document.getElementById('initial_max_bid_' + productId);
    if (initialInput) {
      initialInput.value = '$' + formatWithCommas(roundedBid);
    }

    // Update the BP summary with the new bid amount
    updateBidSummary(productId, roundedBid);

    // Reset the button state
    var confirmButton = document.getElementById('confirm_button_' + productId);
    if (confirmButton) {
      confirmButton.classList.remove('button-update');
      confirmButton.textContent = 'Confirm Bid';
      confirmButton.onclick = function() { submitBidForm(productId); };
    }
  }

  // Function to set up bid change listener
  function setupBidChangeListener(productId) {
    var bidInput = document.getElementById('max_bid_' + productId + '_lightbox');
    var confirmButton = document.getElementById('confirm_button_' + productId);

    if (!bidInput || !confirmButton) return;

    // Remove any existing listeners
    bidInput.removeEventListener('input', bidInput._changeHandler);

    // Create and store the handler
    bidInput._changeHandler = function() {
      var initialBid = parseFloat(bidInput.getAttribute('data-initial-bid'));
      var currentValue = bidInput.value.replace(/[^0-9.]/g, '');
      var currentBid = parseFloat(currentValue);

      // Update BP summary as user types
      if (!isNaN(currentBid) && currentBid > 0) {
        updateBidSummary(productId, currentBid);
      }

      if (!isNaN(currentBid) && Math.abs(currentBid - initialBid) > 0.01) {
        // Bid has changed - show Update button
        confirmButton.textContent = 'Update';
        confirmButton.classList.add('button-update');
        confirmButton.onclick = function() { updateBid(productId); };
      } else {
        // Bid is same as initial
        confirmButton.classList.remove('button-update');
        confirmButton.textContent = 'Confirm Bid';
        confirmButton.onclick = function() { submitBidForm(productId); };
      }
    };

    bidInput.addEventListener('input', bidInput._changeHandler);
  }

  // Bid strategies deprecated — all bids use slow & steady logic


  // Restrict bid input functionality (at module scope so initProduct can reference it)
  function restrictBidInput(event) {
    var input = event.target;
    var key = event.key;
    var value = input.value;

    // Allow control keys (e.g., backspace, tab, arrows)
    var controlKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];

    // Handle Enter key - trigger the appropriate submit button
    if (key === 'Enter') {
      event.preventDefault();
      var productId = input.id.replace('initial_max_bid_', '').replace('_lightbox', '');

      // Check if we're in the lightbox or the initial form
      if (input.id.includes('_lightbox')) {
        // In lightbox - trigger the confirm button
        var confirmButton = document.getElementById('confirm_button_' + productId);
        if (confirmButton && !confirmButton.disabled) {
          confirmButton.click();
        }
      } else {
        // In initial form - trigger the Review & Submit Bid button
        var submitButton = document.getElementById('open_bid_lightbox_button_' + productId);
        if (submitButton) {
          submitButton.click();
        }
      }
      return;
    }

    // Allow one dollar sign, but only at the beginning
    if (key === '$' && value.indexOf('$') !== -1) event.preventDefault();
    else if (key === '$' && input.selectionStart !== 0) event.preventDefault();

    // Allow one period (.)
    if (key === '.' && value.indexOf('.') !== -1) event.preventDefault();

    // Prevent letters and other special characters except control keys
    // Note: We don't need to handle commas here since formatInputWithCommas will add them automatically
    if (!controlKeys.includes(key) && !/[0-9.]/.test(key)) event.preventDefault();
  }

  // Function to format input with commas as user types (at module scope so initProduct can reference it)
  function formatInputWithCommas(input) {
    var cursorPosition = input.selectionStart;
    var oldValue = input.value;

    // Count digits and check if cursor is after decimal point
    var valueBeforeCursor = oldValue.substring(0, cursorPosition);
    var digitsBeforeCursor = (valueBeforeCursor.match(/\d/g) || []).length;
    var wasAfterDecimal = valueBeforeCursor.includes('.');

    // Remove all formatting except numbers and decimal point
    var value = input.value.replace(/[^0-9.]/g, '');

    // Split into integer and decimal parts
    var parts = value.split('.');
    var integerPart = parts[0];
    var decimalPart = parts[1];

    // Add commas to integer part
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // Reconstruct the value
    var formattedValue = integerPart;
    if (parts.length > 1) {
      formattedValue += '.' + (decimalPart || '');
    }

    // Add dollar sign if there's a value
    if (formattedValue) {
      formattedValue = '$' + formattedValue;
    }

    input.value = formattedValue;

    // Calculate new cursor position
    var newCursorPosition = 0;

    if (wasAfterDecimal) {
      // If cursor was after decimal, place it after the decimal in new value
      var decimalIndex = formattedValue.indexOf('.');
      if (decimalIndex !== -1) {
        // Count how many decimal digits were before cursor
        var oldDecimalIndex = oldValue.indexOf('.');
        var decimalDigitsBeforeCursor = oldDecimalIndex !== -1 && cursorPosition > oldDecimalIndex
          ? cursorPosition - oldDecimalIndex - 1
          : 0;
        newCursorPosition = decimalIndex + 1 + decimalDigitsBeforeCursor;
      } else {
        newCursorPosition = formattedValue.length;
      }
    } else {
      // Cursor was in integer part - count digits to find position
      var digitCount = 0;
      for (var i = 0; i < formattedValue.length; i++) {
        if (/\d/.test(formattedValue[i])) {
          digitCount++;
        }
        if (digitCount === digitsBeforeCursor) {
          newCursorPosition = i + 1;
          break;
        }
      }

      // If we haven't found the position yet, place cursor at the end
      if (newCursorPosition === 0) {
        newCursorPosition = formattedValue.length;
      }
    }

    input.setSelectionRange(newCursorPosition, newCursorPosition);
  }

  // Updated closeBidSubmissionLightbox function (single global definition)
  function closeBidSubmissionLightbox(productId, fromPopState) {
    if (fromPopState === undefined) fromPopState = false;

    var lightbox = document.getElementById('hub-bid-lightbox-' + productId);
    if (lightbox && lightbox.style.display === 'flex') {
      lightbox.style.display = 'none';
      isLightboxOpen = false;

      // If not called from popstate, go back in history to remove the pushed state
      if (!fromPopState && window.history.state && window.history.state.lightboxOpen) {
        window.history.back();
      }

      // Re-enable scrolling on the body
      document.body.style.overflow = '';

      // Clear any error or success messages
      var messageElement = document.getElementById('bid_submission_message_' + productId);
      if (messageElement) {
        messageElement.style.display = 'none';
        messageElement.innerHTML = '';
      }
    }
  }

  // Submit the bid from the lightbox
  async function submitBidForm(productId) {
    if (isBanned()) { applyBannedLockdown(); return; }
    var submitButton = document.getElementById('confirm_button_' + productId);
    var messageElement = document.getElementById('bid_submission_message_' + productId);

    if (!submitButton) return;

    // Defensive: refuse to submit if bidding hasn't opened yet. The UI is
    // already hidden by html.mhv-bidding-bidding (CSS in mhv-bidding-phase.css),
    // but this guards against DOM hacks and the brief flash before phase resolves.
    if (window.MHV_BIDDING_PHASE === 'bidding') {
      if (messageElement) {
        messageElement.style.display = 'inline';
        messageElement.style.color = 'var(--mhv-warning-orange)';
        messageElement.innerHTML = 'Bidding hasn\'t opened yet — please wait for the countdown to finish.';
      }
      return;
    }

    // Get bid amount early for duplicate checking
    var maxBidInputEarly = document.getElementById('max_bid_' + productId + '_lightbox');
    var numericMaxBidEarly = maxBidInputEarly ? maxBidInputEarly.value.replace(/[^0-9.]/g, '') : '0';
    var maxBidEarly = parseFloat(numericMaxBidEarly);

    // Check for duplicate submission prevention
    var now = Date.now();
    var tracker = bidSubmissionTracker[productId];

    if (tracker) {
      // Check if there's already an in-flight request
      if (tracker.inFlight) {
        console.log('Bid submission already in progress, ignoring duplicate click');
        return;
      }

      // Check if this is the same bid amount within the prevention window
      if (tracker.bidAmount === maxBidEarly &&
          (now - tracker.timestamp) < DUPLICATE_PREVENTION_WINDOW) {
        console.log('Duplicate bid detected within prevention window, ignoring');
        if (messageElement) {
          messageElement.style.display = 'inline';
          messageElement.style.color = 'var(--mhv-warning-orange)';
          messageElement.innerHTML = 'This bid was just submitted. Please wait a moment before trying again.';
        }
        return;
      }
    }

    // Mark this submission as in-flight
    bidSubmissionTracker[productId] = {
      timestamp: now,
      bidAmount: maxBidEarly,
      inFlight: true
    };

    // Disable the button and start ellipsis animation
    submitButton.disabled = true;
    var dots = 0;
    var animationInterval = setInterval(function() {
      dots = (dots + 1) % 4;
      submitButton.innerHTML = 'Submitting' + '.'.repeat(dots);
    }, 300);
    submitButton.animationInterval = animationInterval;

    // Get form values
    var customerEmailVal = document.getElementById('customer_email_' + productId).value;
    var customerFirstName = document.getElementById('customer_first_name_' + productId).value;
    var bidderNumber = document.getElementById('customer_bidder_number_' + productId).value;
    var consignorNumberEl = document.getElementById('customer_consignor_number_' + productId);
    var consignorNumber = consignorNumberEl ? consignorNumberEl.value : '';
    var screenNameCC = document.getElementById('customer_screen_name_cc_' + productId).value;
    var productTitle = document.getElementById('product_title_' + productId).value;
    var productHandle = document.getElementById('product_handle_' + productId).value;
    var productImageEl = document.getElementById('product_image_' + productId);
    var productImage = productImageEl ? productImageEl.value : '';
    var maxBidInput = document.getElementById('max_bid_' + productId + '_lightbox');
    var numericMaxBid = maxBidInput.value.replace(/[^0-9.]/g, '');
    var maxBid = parseFloat(numericMaxBid);
    var productLot = document.getElementById('product_lot_' + productId).value;

    // Validate bid amount
    if (isNaN(maxBid) || maxBid <= 0) {
      // Clear in-flight flag on validation error
      if (bidSubmissionTracker[productId]) {
        bidSubmissionTracker[productId].inFlight = false;
      }
      if (submitButton.animationInterval) clearInterval(submitButton.animationInterval);
      messageElement.style.display = 'inline';
      messageElement.style.color = 'var(--mhv-error)';
      messageElement.innerHTML = 'Please enter a valid bid amount.';
      submitButton.innerHTML = 'Confirm Bid';
      submitButton.disabled = false;

      return;
    }

    // Confirm unusually large bids — a max bid is binding and can't be lowered, so
    // double-check a possible fat-finger before submitting (LOG-46).
    if (maxBid >= 5000) {
      var okBig = (window.MHV && MHV.confirm)
        ? await MHV.confirm('Confirm your maximum bid of $' + maxBid.toLocaleString() + '? Max bids are binding and cannot be lowered.', { title: 'Confirm High Bid', okText: 'Yes, bid this' })
        : window.confirm('Confirm your maximum bid of $' + maxBid.toLocaleString() + '? This is binding and cannot be lowered.');
      if (!okBig) {
        if (bidSubmissionTracker[productId]) bidSubmissionTracker[productId].inFlight = false;
        if (submitButton.animationInterval) clearInterval(submitButton.animationInterval);
        submitButton.innerHTML = 'Confirm Bid';
        submitButton.disabled = false;
        return;
      }
    }

    // Ensure the bid is rounded down to nearest $0.50 increment
    var finalBid = roundDownToHalfDollar(maxBid);

    // Minimum bid floor: $1 baseline or per-item minimum_bid metafield, whichever is higher.
    // Items without minimum_bid keep the original $1 floor.
    var minimumBid = 1.00;
    var perItemMinInputSubmit = document.getElementById('quickbid_minimum_bid_' + productId);
    if (perItemMinInputSubmit) {
      var perItemMinSubmit = parseFloat(perItemMinInputSubmit.value) || 0;
      if (perItemMinSubmit > minimumBid) minimumBid = perItemMinSubmit;
    }

    // Check if the final bid meets the minimum bid requirement
    if (finalBid < minimumBid) {
      // Clear in-flight flag on validation error
      if (bidSubmissionTracker[productId]) {
        bidSubmissionTracker[productId].inFlight = false;
      }
      if (submitButton.animationInterval) clearInterval(submitButton.animationInterval);
      messageElement.style.display = 'inline';
      messageElement.style.color = 'var(--mhv-error)';
      messageElement.innerHTML = '$' + minimumBid.toFixed(2) + ' is the minimum bid for this lot.';
      submitButton.innerHTML = 'Confirm Bid';
      submitButton.disabled = false;

      return;
    }

    // Get the current bid amount
    var currentBidElement = document.getElementById('current_bid_' + productId);
    var currentBid = 0;
    if (currentBidElement) {
      var currentBidText = currentBidElement.textContent;
      var currentBidMatch = currentBidText.match(/\$?([\d,]+(?:\.\d{2})?)/);
      if (currentBidMatch) {
        currentBid = parseFloat(currentBidMatch[1].replace(/,/g, ''));
      }
    }

    // Check if the new bid is at least $1.00 greater than the current bid
    // Use a small tolerance (0.01) to handle floating point precision
    if (currentBid > 0 && finalBid < currentBid + 0.99) {
      // Clear in-flight flag on validation error
      if (bidSubmissionTracker[productId]) {
        bidSubmissionTracker[productId].inFlight = false;
      }
      if (submitButton.animationInterval) clearInterval(submitButton.animationInterval);
      messageElement.style.display = 'inline';
      messageElement.style.color = 'var(--mhv-error)';
      messageElement.innerHTML = 'Your bid must be at least $1.00 greater than the current bid.';
      submitButton.innerHTML = 'Confirm Bid';
      submitButton.disabled = false;

      return;
    }

    try {
      // Send the data to the server
      var response = await mhvFetch(MHV.SERVER_URL + '/update-metafields', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          product_id: productId,
          customer_email: customerEmailVal,
          customer_first_name: customerFirstName,
          bidder_number: bidderNumber,
          consignor_number: consignorNumber,
          screen_name_cc: screenNameCC,
          product_title: productTitle,
          product_handle: productHandle,
          product_image: productImage,
          max_bid: finalBid,
          product_lot: productLot,
          bid_strategy: 'slow',
          collection_handle: config.collectionHandle || ''
        })
      });

      var data = await response.json();
      // Banned mid-auction → the server rejects with 403. Lock the bidder out everywhere.
      if (response.status === 403 && data && /ban/i.test(String(data.error || ''))) {
        if (bidSubmissionTracker[productId]) bidSubmissionTracker[productId].inFlight = false;
        applyBannedLockdown(data.error);
        return;
      }
      // Phone not verified (new accounts) → open the verify modal, then retry this bid.
      if (response.status === 403 && data && data.error === 'PHONE_VERIFICATION_REQUIRED') {
        if (bidSubmissionTracker[productId]) bidSubmissionTracker[productId].inFlight = false;
        if (window.MHVVerify) {
          window.MHVVerify.open({ message: 'Please verify your phone number to place your bid.', onVerified: function () { submitBidForm(productId); } });
        } else {
          alert('Please verify your phone number before bidding.');
        }
        return;
      }
      // Not registered for this auction → open the registration modal, then retry the bid.
      if (response.status === 403 && data && data.error === 'AUCTION_REGISTRATION_REQUIRED') {
        if (bidSubmissionTracker[productId]) bidSubmissionTracker[productId].inFlight = false;
        var _ac = (data.auctionCode || config.collectionHandle || '');
        openAuctionRegister(_ac, function () { submitBidForm(productId); });
        return;
      }
      if (response.ok) {
        // Mark submission as complete (not in-flight) but keep the timestamp for duplicate prevention
        if (bidSubmissionTracker[productId]) {
          bidSubmissionTracker[productId].inFlight = false;
        }

        // Display success message
        messageElement.style.display = 'inline';
        messageElement.style.fontWeight = 'bold';

        // Hide the minimum bid block if this is the first bid
        var minimumBidBlock = document.getElementById('minimum_bid_block_' + productId);
        if (minimumBidBlock) {
          minimumBidBlock.style.display = 'none';
          // Also hide the <br> that comes after it to prevent extra space
          var nextElement = minimumBidBlock.nextElementSibling;
          if (nextElement && nextElement.tagName === 'BR') {
            nextElement.style.display = 'none';
          }
        }
        // Update the current bid amount on UI
        var currentBidEl = document.getElementById('current_bid_' + productId);
        if (currentBidEl) currentBidEl.innerHTML = '$' + formatWithCommas(data.updated_current_bid);

        // Update the bid_info_display section (hidden initially, shown after first bid)
        var bidInfoDisplayElement = document.getElementById('bid_info_display_' + productId);
        if (bidInfoDisplayElement) {
          bidInfoDisplayElement.style.display = 'block';

          // Update current bid in this section
          var currentBidInInfo = bidInfoDisplayElement.querySelector('#current_bid_' + productId);
          if (currentBidInInfo) {
            currentBidInInfo.innerHTML = '$' + formatWithCommas(data.updated_current_bid);
          }

          // Update max bid display in this section (uses unique _info suffix)
          var maxBidDisplayInInfo = document.getElementById('user_max_bid_display_info_' + productId);
          var maxBidLabelInInfo = document.getElementById('max_bid_label_info_' + productId);

          var maxBidColor = data.high_bidder ? 'var(--mhv-success)' : 'var(--mhv-error)';

          if (maxBidDisplayInInfo) {
            maxBidDisplayInInfo.textContent = '$' + formatWithCommas(finalBid);
            if (maxBidLabelInInfo) {
              maxBidLabelInInfo.style.color = maxBidColor;
            }
          } else {
            // Create the max bid display in bid_info_display section
            var currentBidSpan = bidInfoDisplayElement.querySelector('span[style*="font-size:0.85em"]');
            if (currentBidSpan) {
              var maxBidLine = document.createElement('br');
              var maxBidSpan = document.createElement('span');
              maxBidSpan.style.fontSize = '0.85em';
              maxBidSpan.innerHTML = '<span id="max_bid_label_info_' + productId + '" style="font-weight: bold; color:' + maxBidColor + ';">Your Max Bid:</span> <span id="user_max_bid_display_info_' + productId + '">$' + formatWithCommas(finalBid) + '</span>';
              currentBidSpan.parentNode.insertBefore(maxBidLine, currentBidSpan.nextSibling);
              currentBidSpan.parentNode.insertBefore(maxBidSpan, maxBidLine.nextSibling);
            }
          }
        }

        // Inside the if (response.ok) block in submitBidForm function, after updating the current bid:
        var numberOfBidsElement = document.getElementById('absentee_number_of_bids_' + productId);
        if (numberOfBidsElement && data.updated_number_of_bids) {
          numberOfBidsElement.innerHTML = data.updated_number_of_bids + ' Bid' + (data.updated_number_of_bids === 1 ? '' : 's');
        }

        // Update fav count if provided in response
        var favCountElement = document.getElementById('fav_count_' + productId);
        if (favCountElement && data.updated_fav_count !== undefined) {
          favCountElement.innerHTML = favGlyph(data.updated_fav_count);
        }

        // Update lightbox bid information (so it's correct if user opens it again)
        var lightboxCurrentBid = document.getElementById('lightbox_current_bid_' + productId);
        if (lightboxCurrentBid) {
          lightboxCurrentBid.textContent = '$' + formatWithCommas(data.updated_current_bid);
        }

        var lightboxBidCount = document.getElementById('lightbox_bid_count_' + productId);
        if (lightboxBidCount && data.updated_number_of_bids) {
          lightboxBidCount.innerHTML = data.updated_number_of_bids + ' Bid' + (data.updated_number_of_bids > 1 ? 's' : '');
        }

        var lightboxFavCount = document.getElementById('lightbox_fav_count_' + productId);
        if (lightboxFavCount && data.updated_fav_count !== undefined) {
          lightboxFavCount.innerHTML = favGlyph(data.updated_fav_count);
        }

        // If this is the first bid, update the "No bids" message in lightbox to show current bid
        var lightboxBidInfo = document.getElementById('lightbox_bid_info_' + productId);
        if (lightboxBidInfo && data.updated_number_of_bids === 1) {
          // First bid - replace "No bids" with current bid info
          lightboxBidInfo.innerHTML = '\
            <span style="color: var(--mhv-accent); font-weight: bold;">Current Bid:</span> <span id="lightbox_current_bid_' + productId + '">$' + formatWithCommas(data.updated_current_bid) + '</span>\
            <span style="margin: 0 6px; color: var(--mhv-text-dim);">|</span>\
            <span style="font-weight: bold;" id="lightbox_bid_count_' + productId + '">1 Bid</span>\
            <span id="lightbox_view_count_' + productId + '" class="mhv-view-count" hidden></span>\
          ';
        }
        // The stats line's neighbours just changed (a first bid swaps "No Bids" for the
        // count; the lightbox line may have been rebuilt) — refill the view counts so
        // their leading " | " is right.
        applyViewCounts();

        // Update message for the user
        if (data.high_bidder) {
          messageElement.style.color = 'var(--mhv-success)';
          messageElement.style.display = 'block';
          messageElement.innerHTML = 'You are the high bidder!';
          // Set the bid input field to the max bid value
          document.getElementById('initial_max_bid_' + productId).value = '$' + formatWithCommas(finalBid);

          // Update or create the max bid display in lightbox (green checkmark)
          var userMaxBidContainer = document.getElementById('user_max_bid_display_container_' + productId);

          if (userMaxBidContainer) {
            // Update existing display - change to green checkmark
            userMaxBidContainer.innerHTML = '\
              <svg style="width: 0.85em; height: 0.85em; vertical-align: middle; color: var(--mhv-success);">\
                ' + ICON_SUCCESS_SVG + '\
              </svg>\
              <span style="font-weight: bold; color:var(--mhv-success);">Your Current Max Bid:</span> <span id="lightbox_max_bid_value_' + productId + '">$' + formatWithCommas(finalBid) + '</span>\
            ';
          } else {
            // Create the max bid display if it doesn't exist
            var lightboxBidInfoForMax = document.getElementById('lightbox_bid_info_' + productId);
            if (lightboxBidInfoForMax) {
              var maxBidDiv = document.createElement('div');
              maxBidDiv.id = 'user_max_bid_display_container_' + productId;
              maxBidDiv.style.cssText = 'margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.2);';
              maxBidDiv.innerHTML = '\
                <svg style="width: 0.85em; height: 0.85em; vertical-align: middle; color: var(--mhv-success);">\
                  ' + ICON_SUCCESS_SVG + '\
                </svg>\
                <span style="font-weight: bold; color:var(--mhv-success);">Your Current Max Bid:</span> <span id="lightbox_max_bid_value_' + productId + '">$' + formatWithCommas(finalBid) + '</span>\
              ';
              lightboxBidInfoForMax.appendChild(maxBidDiv);
            }
          }
        } else if (data.outbid) {
          messageElement.style.color = 'var(--mhv-error)';
          messageElement.style.display = 'block';
          messageElement.innerHTML = 'You were outbid!';
          // Clear the bid input field
          document.getElementById('initial_max_bid_' + productId).value = '';

          // Update the max bid display to show red X (not remove it)
          var userMaxBidContainerOutbid = document.getElementById('user_max_bid_display_container_' + productId);
          if (userMaxBidContainerOutbid) {
            // Update to red X
            userMaxBidContainerOutbid.innerHTML = '\
              <svg style="width: 0.85em; height: 0.85em; vertical-align: middle; color: var(--mhv-error);">\
                ' + ICON_ERROR_SVG + '\
              </svg>\
              <span style="font-weight: bold; color:var(--mhv-error);">Your Current Max Bid:</span> <span id="lightbox_max_bid_value_' + productId + '">$' + formatWithCommas(finalBid) + '</span>\
            ';
          } else {
            // Create the max bid display with red X if it doesn't exist
            var lightboxBidInfoForOutbid = document.getElementById('lightbox_bid_info_' + productId);
            if (lightboxBidInfoForOutbid) {
              var maxBidDivOutbid = document.createElement('div');
              maxBidDivOutbid.id = 'user_max_bid_display_container_' + productId;
              maxBidDivOutbid.style.cssText = 'margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(255, 255, 255, 0.2);';
              maxBidDivOutbid.innerHTML = '\
                <svg style="width: 0.85em; height: 0.85em; vertical-align: middle; color: var(--mhv-error);">\
                  ' + ICON_ERROR_SVG + '\
                </svg>\
                <span style="font-weight: bold; color:var(--mhv-error);">Your Current Max Bid:</span> <span id="lightbox_max_bid_value_' + productId + '">$' + formatWithCommas(finalBid) + '</span>\
              ';
              lightboxBidInfoForOutbid.appendChild(maxBidDivOutbid);
            }
          }
        }

        // Update the max bid display in the main card (visible section with current bid)
        // Find the main user_max_bid_display (not in bid_info_display)
        var mainMaxBidDisplay = null;
        var allMaxBidDisplays = document.querySelectorAll('#user_max_bid_display_' + productId);

        for (var d = 0; d < allMaxBidDisplays.length; d++) {
          // Find the one that's NOT inside bid_info_display
          if (!allMaxBidDisplays[d].closest('#bid_info_display_' + productId)) {
            mainMaxBidDisplay = allMaxBidDisplays[d];
            break;
          }
        }

        var maxBidColorMain = data.high_bidder ? 'var(--mhv-success)' : 'var(--mhv-error)';

        if (mainMaxBidDisplay) {
          // Update existing main display
          mainMaxBidDisplay.textContent = '$' + formatWithCommas(finalBid);

          // Update the label color
          var labelEl = document.getElementById('max_bid_label_' + productId);
          if (labelEl) {
            labelEl.style.color = maxBidColorMain;
          }

          // Make sure it's visible
          var parentSpan = mainMaxBidDisplay.closest('span');
          if (parentSpan) {
            parentSpan.style.display = 'inline';
          }
        } else {
          // Main display doesn't exist - create it
          // Find the current bid element that's NOT in bid_info_display
          var allCurrentBidElements = document.querySelectorAll('#current_bid_' + productId);

          for (var c = 0; c < allCurrentBidElements.length; c++) {
            var currentBidElLoop = allCurrentBidElements[c];
            // Skip if this is inside bid_info_display
            if (currentBidElLoop.closest('#bid_info_display_' + productId)) continue;

            // This is the main visible section - find the info icon
            var infoIcon = currentBidElLoop.parentElement;
            while (infoIcon && !infoIcon.querySelector('.info-icon')) {
              infoIcon = infoIcon.parentElement;
            }

            if (infoIcon) {
              var actualIcon = infoIcon.querySelector('.info-icon');
              if (actualIcon) {
                var maxBidLineNew = document.createElement('br');
                var maxBidSpanNew = document.createElement('span');
                maxBidSpanNew.style.fontSize = '0.85em';
                maxBidSpanNew.innerHTML = '<span id="max_bid_label_' + productId + '" style="font-weight: bold; color:' + maxBidColorMain + ';">Your Max Bid:</span> <span id="user_max_bid_display_' + productId + '">$' + formatWithCommas(finalBid) + '</span>';

                // Insert after the info icon
                if (actualIcon.nextSibling) {
                  actualIcon.parentNode.insertBefore(maxBidLineNew, actualIcon.nextSibling);
                  actualIcon.parentNode.insertBefore(maxBidSpanNew, maxBidLineNew.nextSibling);
                } else {
                  actualIcon.parentNode.appendChild(maxBidLineNew);
                  actualIcon.parentNode.appendChild(maxBidSpanNew);
                }
                break; // Only create once
              }
            }
          }
        }

        // Update high bidder or outbid message
        var bidderStatusMessageElement = document.getElementById('bidder_status_message_' + productId);
        if (bidderStatusMessageElement) {
          if (data.high_bidder) {
            bidderStatusMessageElement.innerHTML = '\
              <br>\
              <span style="font-weight: bold; font-size:0.75em;">\
                <svg style="width: 0.85em; height: 0.85em; vertical-align: middle;">\
                  ' + ICON_SUCCESS_SVG + '\
                </svg>\
                You are the high bidder!\
              </span>\
            ';
          } else if (data.outbid) {
            bidderStatusMessageElement.innerHTML = '\
              <br>\
              <span style="font-weight: bold; font-size:0.75em;">\
                <svg style="width: 0.85em; height: 0.85em; vertical-align: middle;">\
                  ' + ICON_ERROR_SVG + '\
                </svg>\
                You have been outbid!\
              </span>\
            ';
          } else {
            // Clear the message if neither high_bidder nor outbid applies
            bidderStatusMessageElement.innerHTML = '';
          }
        }

        // Update quick bid section based on bid result
        var quickBidSection = document.getElementById('quick_bid_section_' + productId);
        if (quickBidSection) {
          if (data.high_bidder) {
            // Hide quick bids if user is now high bidder
            quickBidSection.style.display = 'none';
          } else {
            // Show quick bids and update amount if user was outbid
            quickBidSection.style.display = '';
            var quickBidContainer = document.getElementById('quick_bid_buttons_' + productId);
            if (quickBidContainer && data.updated_current_bid) {
              var successInc = quickBidIncrementsFor(data.updated_current_bid);
              var successLow = Math.ceil(data.updated_current_bid + successInc[0]);
              var successHigh = Math.ceil(data.updated_current_bid + successInc[1]);
              quickBidContainer.innerHTML = buildQuickBidButtonsHtml(productId, successLow, successHigh);
            }
          }
        }

        // Clear animation and close lightbox after 1 second
        if (submitButton.animationInterval) clearInterval(submitButton.animationInterval);
        submitButton.innerHTML = 'Success!';
        setTimeout(function() {
          closeBidSubmissionLightbox(productId);
          submitButton.disabled = false;
          submitButton.innerHTML = 'Confirm Bid';
          messageElement.style.display = 'none';
    
        }, 1000);

      } else {
        // Clear in-flight flag on error so user can retry
        if (bidSubmissionTracker[productId]) {
          bidSubmissionTracker[productId].inFlight = false;
        }

        // Display error message
        if (submitButton.animationInterval) clearInterval(submitButton.animationInterval);
        submitButton.innerHTML = 'Confirm Bid';
        submitButton.disabled = false;
        messageElement.style.display = 'inline';
        messageElement.style.color = 'var(--mhv-error)';
        messageElement.textContent = 'Error: ' + data.message;
        maxBidInput.readOnly = false;
  
      }
    } catch (error) {
      // Clear in-flight flag on error so user can retry
      if (bidSubmissionTracker[productId]) {
        bidSubmissionTracker[productId].inFlight = false;
      }

      // Display submission error
      if (submitButton.animationInterval) clearInterval(submitButton.animationInterval);
      submitButton.innerHTML = 'Confirm Bid';
      submitButton.disabled = false;
      messageElement.style.display = 'inline';
      messageElement.style.color = 'var(--mhv-error)';
      messageElement.innerHTML = 'Error submitting your bid. Please try again.';
      maxBidInput.readOnly = false;

    }
  }

  // Function to update fav count display
  function updateFavCountDisplay(productId, newFavCount) {
    var favCountElement = document.getElementById('fav_count_' + productId);
    var bidCountElement = document.getElementById('absentee_number_of_bids_' + productId);
    var parentSpan = favCountElement ? favCountElement.parentElement : null;

    if (newFavCount > 0) {
      if (favCountElement) {
        // Add animation class
        favCountElement.classList.add('fav-count-roll-up');
        favCountElement.innerHTML = favGlyph(newFavCount);

        // Remove animation class after animation completes
        setTimeout(function() {
          favCountElement.classList.remove('fav-count-roll-up');
        }, 600);
      } else {
        // Create fav count element if it doesn't exist
        var newFavElement = document.createElement('span');
        newFavElement.id = 'fav_count_' + productId;
        newFavElement.className = 'fav-count-animation fav-count-roll-up';
        newFavElement.innerHTML = favGlyph(newFavCount);

        // Bids | Favs | Views — a fav created here lands before the views placeholder
        // (the last child of the stats line), never after it.
        var viewsEl = parentSpan ? parentSpan.querySelector('.mhv-view-count') : null;
        if (bidCountElement && parentSpan) {
          // Add separator and fav count after bid count
          var separator = document.createTextNode(' | ');
          parentSpan.insertBefore(separator, viewsEl);
          parentSpan.insertBefore(newFavElement, viewsEl);
        } else if (parentSpan) {
          // Just add fav count if no bid count
          parentSpan.insertBefore(newFavElement, viewsEl);
        }
        applyViewCounts();   // the separator before the views may have changed

        // Remove animation class after animation completes
        setTimeout(function() {
          newFavElement.classList.remove('fav-count-roll-up');
        }, 600);
      }
    } else {
      // Remove fav count if it's 0
      if (favCountElement) {
        var prevSibling = favCountElement.previousSibling;
        if (prevSibling && prevSibling.textContent.trim() === '|') {
          favCountElement.remove();
          prevSibling.remove();
        } else {
          favCountElement.remove();
        }
      }
    }
  }

  // Global function for optimistic fav count updates
  window.optimisticFavUpdate = function(productId, isAdding) {
    var favCountElement = document.getElementById('fav_count_' + productId);
    var currentCount = 0;

    if (favCountElement) {
      // Extract the number from the text, e.g., "3 Favs"
      var match = favCountElement.textContent.match(/(\d+)/);
      if (match) {
        currentCount = parseInt(match[1], 10);
      }
    }

    // Optimistically update the count
    var newCount = isAdding ? currentCount + 1 : Math.max(0, currentCount - 1);
    updateFavCountDisplay(productId, newCount);

    return { currentCount: currentCount, newCount: newCount };
  };

  // Per-product initialization function
  function initProduct(productId) {
    // Attach the input restriction to the initial bid input
    var initialBidInput = document.getElementById('initial_max_bid_' + productId);
    if (initialBidInput) {
      initialBidInput.addEventListener('keydown', restrictBidInput);
      initialBidInput.addEventListener('input', function() {
        formatInputWithCommas(this);
      });
    }

    // Attach the input restriction to the lightbox bid input
    var lightboxBidInput = document.getElementById('max_bid_' + productId + '_lightbox');
    if (lightboxBidInput) {
      lightboxBidInput.addEventListener('keydown', restrictBidInput);
      lightboxBidInput.addEventListener('input', function() {
        formatInputWithCommas(this);
      });
    }

    // Prevent form submission on Enter key (handle it in restrictBidInput instead)
    var bidForm = document.getElementById('initial_bid_form_' + productId);
    if (bidForm) {
      bidForm.addEventListener('submit', function(event) {
        event.preventDefault();
        return false;
      });
    }

    // Also prevent form submission in the lightbox form
    var lightboxForm = document.getElementById('bid_form_' + productId);
    if (lightboxForm) {
      lightboxForm.addEventListener('submit', function(event) {
        event.preventDefault();
        return false;
      });
    }
  }

  // ONE-TIME setup on DOMContentLoaded
  // ── Linked consignors: an estate's PR cannot bid on the estate's lots ──────
  // Liquid marks a lot "Your Consignment" only for the customer's OWN consignor
  // number. Someone who represents a consignor as a linked contact (a PR on an
  // estate) has a different number, so the estate's lots rendered as biddable.
  // /api/my-consignor-access returns own + linked; for any linked consignor the
  // card's bid UI is swapped for the notice. The server refuses the bid too — this
  // is what the person SEES, not the only thing standing between them and a bid.
  (function linkedConsignorGuard() {
    if (!config.customerId && !config.bidderNumber) return;   // logged out: nothing to look up
    function apply(list) {
      var linkedTags = (list || []).filter(function(c) { return c && !c.own && c.consignorNumber; })
        .map(function(c) { return String(c.consignorNumber).toLowerCase() + '-consignment'; });
      if (!linkedTags.length) return;
      document.querySelectorAll('[data-mhv-bid-ui]').forEach(function(ui) {
        var tags = (ui.getAttribute('data-consignment-tags') || '').split(/\s+/);
        var hit = tags.some(function(t) { return t && linkedTags.indexOf(t) >= 0; });
        if (!hit) return;
        ui.style.display = 'none';
        var pid = ui.getAttribute('data-mhv-bid-ui');
        var notice = document.querySelector('[data-mhv-linked-notice="' + pid + '"]');
        if (notice) notice.style.display = '';
        var item = ui.closest('.grid__item');
        if (item) item.classList.add('my-consignment');
      });
    }
    function run() {
      var f = window.mhvFetch || window.fetch;
      f(MHV.SERVER_URL + '/api/my-consignor-access')
        .then(function(r) { return r.json(); })
        .then(function(d) { apply((d && d.consignors) || []); })
        .catch(function() { /* the server refuses such a bid anyway */ });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  document.addEventListener('DOMContentLoaded', function() {

    // Attach click event listeners to all buttons for opening the lightbox
    document.querySelectorAll('.max-bid-submit-btn').forEach(function(button) {
      button.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent any default form behavior

        var productId = this.id.replace('open_bid_lightbox_button_', '');
        var bidInputField = document.getElementById('initial_max_bid_' + productId);
        var originalBidValue = bidInputField.value.trim();
        var numericBidValue = originalBidValue.replace(/[^0-9.]/g, '');
        var errorMessage = document.getElementById('bid_error_message_' + productId);

        if (!numericBidValue || isNaN(parseFloat(numericBidValue)) || parseFloat(numericBidValue) <= 0) {
          errorMessage.style.display = 'inline';
          errorMessage.innerHTML = '<p>Please enter a valid bid amount.</p>';
          return;
        }

        // Round down to nearest $0.50 increment
        var roundedBid = roundDownToHalfDollar(parseFloat(numericBidValue));

        // Floor: $1.00 baseline OR the per-item minimum_bid metafield, whichever is higher.
        // Items without a minimum_bid metafield keep the original $1 floor.
        var minimumBid = 1.00;
        var perItemMinInput = document.getElementById('quickbid_minimum_bid_' + productId);
        if (perItemMinInput) {
          var perItemMin = parseFloat(perItemMinInput.value) || 0;
          if (perItemMin > minimumBid) minimumBid = perItemMin;
        }

        // Check if the rounded bid meets the minimum bid requirement — block before the lightbox opens
        if (roundedBid < minimumBid) {
          errorMessage.style.display = 'inline';
          errorMessage.innerHTML = '<p>$' + minimumBid.toFixed(2) + ' is the minimum bid for this lot.</p>';
          return;
        }

        // Get the current bid amount
        var currentBidElement = document.getElementById('current_bid_' + productId);
        var currentBid = 0;
        if (currentBidElement) {
          var currentBidText = currentBidElement.textContent;
          var currentBidMatch = currentBidText.match(/\$?([\d,]+(?:\.\d{2})?)/);
          if (currentBidMatch) {
            currentBid = parseFloat(currentBidMatch[1].replace(/,/g, ''));
          }
        }

        // Check if the new bid is at least $1.00 greater than the current bid
        // Use a small tolerance (0.01) to handle floating point precision
        if (currentBid > 0 && roundedBid < currentBid + 0.99) {
          errorMessage.style.display = 'inline';
          errorMessage.innerHTML = '<p>Your bid must be at least $1.00 greater than the current bid.</p>';
          return;
        }

        errorMessage.style.display = 'none';

        var bidInputInLightbox = document.getElementById('max_bid_' + productId + '_lightbox');
        bidInputInLightbox.value = '$' + formatWithCommas(roundedBid);
        bidInputInLightbox.readOnly = false; // Make the bid input editable

        // Store the initial bid value for comparison
        bidInputInLightbox.setAttribute('data-initial-bid', roundedBid.toFixed(2));

        // Update BP summary before showing lightbox
        updateBidSummary(productId, roundedBid);

        // Reset the confirm button state
        var confirmButton = document.getElementById('confirm_button_' + productId);
        if (confirmButton) {
          confirmButton.classList.remove('button-update');
          confirmButton.textContent = 'Confirm Bid';
          confirmButton.onclick = function() { submitBidForm(productId); };
        }

        // Add input listener to detect bid changes
        setupBidChangeListener(productId);

        document.getElementById('hub-bid-lightbox-' + productId).style.display = 'flex';

        // Track the lightbox state
        isLightboxOpen = true;

        // Push a history state to handle Android back button
        window.history.pushState({ lightboxOpen: true }, '');

        // Disable scrolling on the body
        document.body.style.overflow = 'hidden';
      });
    });

    // Event listener for popstate to close lightbox when back button is pressed
    window.addEventListener('popstate', function(event) {
      if (isLightboxOpen) {
        // Close lightbox if it is open, passing true to indicate this is from popstate
        var openLightbox = document.querySelector('.lightbox-hub-bid[style*="display: flex"]');
        if (openLightbox) {
          var productId = openLightbox.id.replace('hub-bid-lightbox-', '');
          closeBidSubmissionLightbox(productId, true);
        }
      }
    });

    // Attach click event listeners to close the lightbox when clicking outside the content
    document.querySelectorAll('.lightbox-hub-bid').forEach(function(lightbox) {
      lightbox.addEventListener('click', function(event) {
        if (event.target === lightbox) {
          var productId = lightbox.id.replace('hub-bid-lightbox-', '');
          closeBidSubmissionLightbox(productId);
        }
      });
    });

    // Attach click event listeners to close buttons within the lightbox
    document.querySelectorAll('.lightbox-absentee-info-close-btn').forEach(function(closeBtn) {
      closeBtn.addEventListener('click', function() {
        var productId = this.closest('.lightbox-hub-bid').id.replace('hub-bid-lightbox-', '');
        closeBidSubmissionLightbox(productId);
      });
    });

    // Attach focus/blur handlers to ALL max bid inputs (only once)
    if (!window._maxBidFocusHandlersAttached) {
      window._maxBidFocusHandlersAttached = true;

      document.querySelectorAll('.max-bid-input').forEach(function(input) {
        // Collapse quick bids when max bid input is focused
        input.addEventListener('focus', function() {
          var productId = this.id.replace('initial_max_bid_', '');
          var quickBidSection = document.getElementById('quick_bid_section_' + productId);
          var helperMessage = document.getElementById('max_bid_helper_' + productId);

          if (quickBidSection && quickBidSection.style.display !== 'none') {
            quickBidSection.classList.add('collapsed');
            if (helperMessage) {
              helperMessage.classList.add('visible');
            }
          }
        });

        // Restore quick bids when max bid input loses focus (if empty)
        input.addEventListener('blur', function() {
          var productId = this.id.replace('initial_max_bid_', '');
          var quickBidSection = document.getElementById('quick_bid_section_' + productId);
          var helperMessage = document.getElementById('max_bid_helper_' + productId);
          var inputValue = this.value.replace(/[^0-9.]/g, '');

          // Only restore if input is empty and user isn't high bidder
          if (!inputValue || parseFloat(inputValue) <= 0) {
            if (quickBidSection) {
              quickBidSection.classList.remove('collapsed');
            }
            if (helperMessage) {
              helperMessage.classList.remove('visible');
            }
          }
        });
      });
    }
  });

  // Invoice status checking for winning lots
  (function() {
    // Only run this once per page load
    if (window._invoiceStatusCheckInitialized) return;
    window._invoiceStatusCheckInitialized = true;

    var PROXY_SERVER_URL = MHV.SERVER_URL;
    var invoiceCustomerEmail = config.customerEmail || '';

    if (!invoiceCustomerEmail) return;

    async function checkInvoiceStatus() {
      var containers = document.querySelectorAll('.invoice-status-container[data-product-id]');
      if (containers.length === 0) return;

      try {
        // Use mhvFetch for deduplication if available (header also calls this)
        var fetchFn = window.mhvFetch || fetch;
        var response = await fetchFn(PROXY_SERVER_URL + '/draft-orders/' + encodeURIComponent(invoiceCustomerEmail));
        var data = await response.json();

        if (!data.success) return;

        var draftOrders = data.draft_orders || [];
        var paidOrders = data.paid_orders || [];

        // Build a map of product IDs to their invoice URLs (unpaid draft orders)
        var productInvoiceMap = {};
        draftOrders.forEach(function(order) {
          if (order.line_items) {
            order.line_items.forEach(function(item) {
              if (item.product_id) {
                productInvoiceMap[item.product_id] = {
                  invoice_url: order.invoice_url,
                  checkout_url: order.checkout_url,
                  order_name: order.name
                };
              }
            });
          }
        });

        // Build a map of product IDs to their paid order info
        var productPaidMap = {};
        paidOrders.forEach(function(item) {
          if (item.product_id) {
            productPaidMap[item.product_id] = {
              order_name: item.order_name,
              order_status_url: item.order_status_url
            };
          }
        });

        // Update each container: paid → unpaid invoice → pending
        containers.forEach(function(container) {
          var productId = container.getAttribute('data-product-id');
          var paidInfo = productPaidMap[productId];
          var invoiceInfo = productInvoiceMap[productId];

          if (paidInfo && paidInfo.order_status_url) {
            // Paid - show View Order link
            container.innerHTML = '<a href="' + escA(paidInfo.order_status_url) + '" target="_blank" class="invoice-paid-btn"><svg aria-hidden="true" focusable="false" viewBox="0 0 13 13" width="13" height="13" style="vertical-align:middle;margin-right:4px;"><path d="M6.5 12.35C9.73087 12.35 12.35 9.73086 12.35 6.5C12.35 3.26913 9.73087 0.65 6.5 0.65C3.26913 0.65 0.65 3.26913 0.65 6.5C0.65 9.73086 3.26913 12.35 6.5 12.35Z" fill="#428445" stroke="white" stroke-width="0.7"/><path d="M5.53271 8.66357L9.25213 4.68197" stroke="white"/><path d="M4.10645 6.7688L6.13766 8.62553" stroke="white"/></svg> Paid - View Order</a>';
          } else if (invoiceInfo && (invoiceInfo.checkout_url || invoiceInfo.invoice_url)) {
            // Invoice available but unpaid - show View Invoice button (new checkout)
            container.innerHTML = '<a href="' + escA(invoiceInfo.checkout_url || invoiceInfo.invoice_url) + '" target="_blank" class="invoice-pay-now-btn">📄 View Invoice</a>';
          } else {
            // No invoice yet - show Invoice Pending badge
            container.innerHTML = '<span class="invoice-pending-badge">⏳ Invoice Pending</span>';
          }
        });

      } catch (error) {
        console.error('Error checking invoice status:', error);
        // On error, show pending badge
        containers.forEach(function(container) {
          container.innerHTML = '<span class="invoice-pending-badge">⏳ Invoice Pending</span>';
        });
      }
    }

    // Run when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkInvoiceStatus);
    } else {
      checkInvoiceStatus();
    }
  })();

  // Expose globally for onclick handlers in Liquid HTML
  window.formatCurrency = formatCurrency;
  window.handleQuickBidClick = handleQuickBidClick;
  // Exposed so auction-hub-banner.js can recompute an OPEN bid box after the authoritative
  // buyer's premium arrives from the event API (see applyAuthoritativeBuyersPremium).
  // Without this the box would keep showing a total derived from the stale Liquid value.
  window.updateBidSummary = updateBidSummary;
  window.closeBidSubmissionLightbox = closeBidSubmissionLightbox;
  window.updateFavCountDisplay = updateFavCountDisplay;
  window.MHV_BID = { initProduct: initProduct };

  // Absentee phase 2: the current-bid badges + bid counts are rendered server-side from
  // Shopify metafields, which a commit syncs best-effort and so lag by ~a second (and
  // the metafield never reflects LIVE bids). Fetch the DB-authoritative values and
  // correct BOTH the current-bid amount and the bid count (which now includes live bids,
  // incl. on sold lots). Best-effort — fails silently. Polled so counts stay fresh.
  function refreshLiveBidsFromDB() {
    try {
      var code = config.collectionHandle;
      if (!code || !/^\d{8}$/.test(code)) return;
      var base = (window.MHV && MHV.SERVER_URL) || '';
      (window.mhvFetch || fetch)(base + '/api/live-bids/' + code)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || !data.bids) return;
          Object.keys(data.bids).forEach(function (pid) {
            var b = data.bids[pid];
            if (b.currentBid != null) {
              var formatted = '$' + Number(b.currentBid).toFixed(2);
              var els = document.querySelectorAll('[id="current_bid_' + pid + '"]');
              for (var i = 0; i < els.length; i++) els[i].textContent = formatted;
            }
            // ⚠️ The QUICK-BID BUTTONS are rendered from the same stale metafield as the
            // badge above, so correcting only the displayed amount left them offering
            // raises off an old number — a lot at $55 showing "Bid $30 / Bid $35",
            // which are below the current bid and would be rejected. Rebuild them from
            // the DB figure too.
            //
            // Amounts ONLY — never visibility. Whether the section is shown depends on
            // whether YOU are the high bidder, which this endpoint does not tell us;
            // toggling it here would re-show the quick-bid row to the person already
            // winning the lot.
            if (b.currentBid != null && Number(b.currentBid) > 0) {
              var qbWraps = document.querySelectorAll('[id="quick_bid_buttons_' + pid + '"]');
              for (var q = 0; q < qbWraps.length; q++) {
                var cur = Number(b.currentBid);
                var qinc = quickBidIncrementsFor(cur);
                qbWraps[q].innerHTML = buildQuickBidButtonsHtml(
                  pid, Math.ceil(cur + qinc[0]), Math.ceil(cur + qinc[1]));
              }
            }
            if (b.numberOfBids != null) {
              var n = Number(b.numberOfBids) || 0;
              // Plain bid count only — the 🔥 Hot Lot badge is managed separately by
              // fetchHotLots() (the composite trending algorithm), NOT a raw bid count.
              var label = n + ' Bid' + (n === 1 ? '' : 's');
              var countEls = document.querySelectorAll('[id="absentee_number_of_bids_' + pid + '"]');
              for (var k = 0; k < countEls.length; k++) countEls[k].innerHTML = label;
            }
          });
          if (Object.keys(viewCounts).length) applyViewCounts();
        })
        .catch(function () { /* best-effort */ });
    } catch (e) { /* best-effort */ }
  }
  if (document.readyState !== 'loading') refreshLiveBidsFromDB();
  else document.addEventListener('DOMContentLoaded', refreshLiveBidsFromDB);
  setInterval(refreshLiveBidsFromDB, 12000);

  // ── Hot Lot badge (composite trending algorithm) ──────────────────────────
  // ⚠️ A hot lot is a lot people are BIDDING on (owner rule 2026-09-13 — bidders
  // had reported the badge on lots reading "No Bids"). The server decides: a lot
  // needs at least one real bid, must clear an absolute bar (roughly: two bidders
  // competing), must stand out among the OTHER lots being bid on, and the set is
  // capped at ~5% of those (min 3). Bid signals lead; favs and views only add. The
  // set comes from GET /api/hot-lots/<code> (which also carries the view counts);
  // the badge sits beside the per-lot price span so the 12s bid refresh never
  // clobbers it. See routes/viewer-routes.js for the weights.
  var hotLotSet = {};
  var viewCounts = {};   // pid → total views, from the same /api/hot-lots response

  // ── "N 👁" beside Bids / ♥ ────────────────────────────────────────────────
  // Liquid renders an empty, hidden #view_count_<pid> (and #lightbox_view_count_)
  // placeholder in every stats line — sold, live, No Bids, the first-bid block,
  // the lightbox — and this fills them all. The " | " is decided HERE, at fill
  // time, by whether anything visible precedes the count: the bidding-phase CSS
  // hides "No Bids" and its separator before bidding opens, and a separator
  // leading a line reads as a typo. Re-run whenever the neighbours change.
  function needsViewSep(el) {
    var prev = el.previousElementSibling;
    while (prev) {
      if (!/separator|-sep\b/.test(prev.className || '') && prev.textContent.replace(/\s|\u00a0/g, '')) {
        var disp = window.getComputedStyle ? getComputedStyle(prev).display : '';
        if (disp !== 'none') return true;
      }
      prev = prev.previousElementSibling;
    }
    return false;
  }
  function applyViewCounts() {
    var els = document.querySelectorAll('.mhv-view-count');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var m = (el.id || '').match(/view_count_(\d+)$/);
      if (!m) continue;
      var n = Number(viewCounts[m[1]]) || 0;
      if (n <= 0) { el.hidden = true; el.innerHTML = ''; continue; }
      el.innerHTML = (needsViewSep(el) ? '<span class="mhv-view-count-sep">&nbsp;|&nbsp;</span>' : '') +
        '<span class="mhv-view-count-text">' + viewGlyph(n) + '</span>';
      el.hidden = false;
      // Pre-open, mhv-bidding-phase-a.css collapses a No-Bids block that has no favs
      // (nothing visible left inside). A view count IS something visible.
      var blk = el.closest && el.closest('[id^="minimum_bid_block_"]');
      if (blk) blk.classList.remove('mhv-no-favs');
    }
  }
  // The bidding-phase script toggles html classes that show/hide the neighbours
  // ("No Bids", the separators); recompute the leading " | " when that happens.
  try {
    new MutationObserver(function () { if (Object.keys(viewCounts).length) applyViewCounts(); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  } catch (e) { /* no observer → the 60s refresh corrects it */ }

  function makeHotBadge() {
    // Original look: bold orange fire text (no pill), on its own line above the price.
    var badge = document.createElement('span');
    badge.className = 'mhv-hotlot-badge';
    badge.textContent = '🔥HotLot🔥';
    badge.style.cssText = 'display:block;margin:0 0 4px 0;font-weight:bold;color:var(--mhv-warning-orange);white-space:nowrap;';
    return badge;
  }
  function applyHotBadges() {
    // The lot's product id lives in the Dawn card-wrapper id (…product-grid-<pid>);
    // the visible per-lot price area is .hub-absentee-product-bid inside it. Anchor
    // there — the #current_bid_/#absentee_number_of_bids_ spans are metafield-gated
    // (absent on an ended auction) or hidden lightbox-only, so they don't work. One
    // badge per lot; dedupe by product id (a lot can appear in more than one card).
    var seen = {};
    var cards = document.querySelectorAll('[id*="product-grid-"]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var m = (card.id || '').match(/product-grid-(\d+)/);
      if (!m) continue;
      var pid = m[1];
      var existing = card.querySelector('.mhv-hotlot-badge');
      var wantBadge = !!hotLotSet[pid] && !seen[pid];
      if (wantBadge) {
        seen[pid] = true;
        if (!existing) {
          var anchor = card.querySelector('.hub-absentee-product-bid') || card.querySelector('.card__information') || card;
          anchor.insertAdjacentElement('afterbegin', makeHotBadge());
        }
      } else if (existing) {
        existing.parentNode.removeChild(existing);
      }
    }
  }
  function fetchHotLots() {
    try {
      var code = config.collectionHandle;
      if (!code || !/^\d{8}$/.test(code)) return;
      var base = (window.MHV && MHV.SERVER_URL) || '';
      (window.mhvFetch || fetch)(base + '/api/hot-lots/' + code)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          hotLotSet = {};
          ((data && data.hot) || []).forEach(function (pid) { hotLotSet[String(pid)] = true; });
          applyHotBadges();
          viewCounts = (data && data.views) || {};
          applyViewCounts();
        })
        .catch(function () { /* best-effort */ });
    } catch (e) { /* best-effort */ }
  }
  if (document.readyState !== 'loading') fetchHotLots();
  else document.addEventListener('DOMContentLoaded', fetchHotLots);
  setInterval(fetchHotLots, 60000); // server caches 60s; no need to poll faster

  // ITEM LIVE indicator — flag whichever card's lot is on the block with .mhv-live-active,
  // which (via CSS) shows the red LIVE badge above the current-bid badge and grays out (but
  // keeps visible) the bidding area. Keyed by SKU. Updated in REAL TIME via the shared
  // chat-widget socket (current-lot-updated), with a 12s poll fallback for fresh loads.
  var _liveSkus = {};

  // ⚠️ A lot being ON THE BLOCK is not the same as the auction being LIVE (tweak 4).
  // /api/current-selling-lot reports whatever the host currently has loaded, and that
  // survives between sales — a lot left showing from a rehearsal, a set-up pass, or
  // the previous auction. So the red "LIVE — tap to bid on the live page" badge could
  // sit on a lot hours before the sale opened, sending bidders to a live page with
  // nothing happening.
  //
  // Require the auction itself to be live. mhv-bidding-phase.js resolves that from
  // /api/schedule/live-status and publishes it as MHV_BIDDING_PHASE + a root class.
  // Unresolved ('loading'/absent) counts as NOT live: a missing badge is a smaller
  // problem than a badge that lies.
  function auctionIsLive() {
    if (window.MHV_BIDDING_PHASE) return window.MHV_BIDDING_PHASE === 'live';
    var r = document.documentElement;
    return !!(r && r.classList.contains('mhv-bidding-live'));
  }

  function applyLiveState() {
    var live = auctionIsLive();
    var cards = document.querySelectorAll('.hub-absentee-product-bid[data-mhv-live-sku]');
    for (var j = 0; j < cards.length; j++) {
      var os = (cards[j].getAttribute('data-mhv-live-sku') || '').toUpperCase();
      if (live && os && _liveSkus[os]) cards[j].classList.add('mhv-live-active');
      else cards[j].classList.remove('mhv-live-active');
    }
  }
  // The phase resolves asynchronously, so re-apply the moment it says we're live —
  // otherwise the badge waits for the next 12s poll after the sale opens.
  document.addEventListener('mhv:bidding-live', applyLiveState);
  function refreshLiveBadges() {
    try {
      var base = (window.MHV && MHV.SERVER_URL) || '';
      (window.mhvFetch || fetch)(base + '/api/current-selling-lot')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          _liveSkus = {};
          ((data && data.skus) || []).forEach(function (s) { _liveSkus[String(s).toUpperCase()] = true; });
          applyLiveState();
        })
        .catch(function () { /* best-effort */ });
    } catch (e) { /* best-effort */ }
  }
  if (document.readyState !== 'loading') refreshLiveBadges();
  else document.addEventListener('DOMContentLoaded', refreshLiveBadges);
  setInterval(refreshLiveBadges, 12000);

  // Real-time: reuse the shared socket (created by the chat widget on this page). When
  // the host shows a new lot, current-lot-updated fires → move the overlay instantly.
  function wireLiveSocket() {
    var s = window.socket;
    if (!s || typeof s.on !== 'function') { setTimeout(wireLiveSocket, 600); return; }
    if (s.__mhvHubLiveWired) return;
    s.__mhvHubLiveWired = true;
    s.on('current-lot-updated', function (d) {
      if (!d) return;
      if (d.sku === 'CLEARED' && d.action === 'clear') { _liveSkus = {}; applyLiveState(); return; }
      if (d.sku && String(d.sku).indexOf('-LOT') !== -1) {
        _liveSkus = {};
        _liveSkus[String(d.sku).toUpperCase()] = true;
        applyLiveState();
      }
    });
    // A live bid landing is a good moment to refresh the DB-authoritative bid counts.
    s.on('live-bid-state', function () { refreshLiveBidsFromDB(); });
  }
  wireLiveSocket();

})();
